import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background: theme.colors.background1,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    color: theme.colors.Background7,
    boxSizing: "border-box",
    width: "100vw",
  },

  frame: {
    display: "flex",
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px ${theme.spacing.space48}px ${theme.spacing.space16}px`,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing.space32,
    flexShrink: 0,
    "@media (max-height: 700px)": {
      gap: theme.spacing.space16,
    },
  },

  header: {
    alignItems: "center",
    height: "70px",
    padding: `0 ${theme.spacing.space16}px`,
    display: "flex",
  },

  logo: {
    display: "flex",
    height: theme.spacing.space32,
    justifyContent: "center",
    alignItems: "center",
  },

  title: {
    textAlign: "center",
    fontStyle: "normal",
    alignSelf: "stretch",
  },

  fieldWrapper: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: `${theme.spacing.space12}px !important`,
    alignSelf: "stretch",
    width: "100%",
  },

  subtitle: {
    textAlign: "center",
    fontStyle: "normal",
    alignSelf: "stretch",
    lineHeight: "22.4px !important",
    fontFeatureSettings: "'liga' off",
  },

  inputTxt: {
    height: theme.spacing.space48,
    padding: theme.spacing.space12,
    alignItems: "center",
    gap: theme.spacing.space16,
    alignSelf: "stretch",
  },
  clearIcon: {
    cursor: "pointer",
    fontSize: 18,
    color: theme.colors.text4,
    userSelect: "none",

    "&:hover": {
      color: theme.colors.Background7,
    },
  },

  avatarGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    flexDirection: "column",
    gap: theme.spacing.space16,
    width: "100%",
    alignItems: "flex-start",
    flex: "1 0 0",
    alignSelf: "stretch",
  },

  avatarItem: {
    display: "flex",
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",

    "& img": {
      width: "100px",
      height: "100px",
      objectFit: "cover",
      opacity: 0.7,
      borderRadius: "50%",
    },
  },
  checkIcon: {
    position: "absolute",
    top: theme.spacing.space4,
    right: theme.spacing.space4,
    width: theme.spacing.space24,
    height: theme.spacing.space24,
    maxWidth: theme.spacing.space24,
    maxHeight: theme.spacing.space24,
    display: "flex",
    padding: "1.25px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    "& img": {
      width: theme.spacing.space24,
      height: theme.spacing.space24,
      objectFit: "contain",
    },
    "@media (max-width: 400px)": {
      right: theme.spacing.space2,
    },
  },

  activeAvatar: {
    "& img": {
      opacity: 1,
    },
  },

  buttonWrapper: {
    position: "fixed",
    bottom: theme.spacing.space16,
    left: theme.spacing.space4,
    right: theme.spacing.space4,
    maxWidth: "92vw",
    margin: "0 auto",

    "@media (min-height: 768px)": {
      bottom: theme.spacing.space40,
    },
  },
  "@media (orientation: landscape)": {
    header: {
      paddingTop: theme.spacing.space4,
      paddingBottom: theme.spacing.space4,
      height: theme.spacing.space40,
    },
    checkIcon: {
      right: "calc((100% - 110px) / 2)",
    },
  },
}));
